<template>
  <div class="companies-select">
    <i-select
      v-model="company"
      placeholder="Компания"
      not-found-text="Нет данных"
      @on-change="onCompanyChange"
    >
      <i-option v-for="item in companies" :value="item.id" :key="item.value">
        {{ item.name }}
      </i-option>
    </i-select>
  </div>
</template>

<script>
import { saveDataToLS } from '@/utils'

export default {
  computed: {
    companies () {
      return [
        { id: 'all', name: 'Все компании' },
        ...this.$store.state.companies
      ]
    },
    company: {
      get () {
        return this.$store.state.filters.company
      },
      set (value) {
        this.$store.commit('SET_COMPANY', value)
      }
    }
  },
  methods: {
    onCompanyChange (value) {
      saveDataToLS('company', value)
    }
  }
}
</script>

<style lang="less">
.companies-select {
  line-height: 40px;
  margin: 0 20px 0 16px;

  .ivu-select {
    width: 140px;

    &-selection {
      background-color: #43526d;
    }

    &-selected-value {
      color: #eee;
    }
  }
}
</style>
